define([
    'edge/platform/atomic_design/molecules/directives/RadiosBinaryDirective'
], (RadiosBinaryDirective)=> {
    return angular.module('edge.platform.atomic_design.molecules', [])
        .directive('gwPlRadiosBinary', RadiosBinaryDirective);
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/atomic_design/molecules/module.js
 **/